// modified from source: https://github.com/apexcharts/apexcharts.js/blob/449f374a8ce35488bdc14c7476f95b59bdb1bc05/src/modules/Exports.js#L186

import LocaleService from 'services/loader-handler-services/locale-service';
import ApexAxesUtils from 'services/apex-chart-services/utils/apex-axes-utils';
import ApexData from 'services/apex-chart-services/utils/apex-data';
import ApexSeries from 'services/apex-chart-services/utils/apex-series';
import ApexUtils from 'services/apex-chart-services/utils/apex-utils';

const ApexChartExportService = {
  exportToCSV: function (chart, data, options) {
    const w = chart.w;
    const series = data.series;
    const columnDelimiter = ';';
    const lineDelimiter = '\n';
    let columns = [];
    const rows = [];
    let result = '';

    this.ctx = chart.ctx;

    const isTimeStamp = num => {
      return w.config.xaxis.type === 'datetime' && String(num).length >= 10;
    };
    const dataFormat = new ApexData(this.ctx);

    const axesUtils = new ApexAxesUtils(this.ctx);
    const getCat = i => {
      let cat = '';

      // pie / donut/ radial
      if (!w.globals.axisCharts) {
        cat = w.config.labels[i];
      } else {
        // xy charts

        // non datetime
        if (w.config.xaxis.type === 'category' || w.config.xaxis.convertedCatToNumeric) {
          if (w.globals.isBarHorizontal) {
            const lbFormatter = w.globals.yLabelFormatters[0];
            const sr = new ApexSeries(this.ctx);
            const activeSeries = sr.getActiveConfigSeriesIndex();

            cat = lbFormatter(w.globals.labels[i], {
              seriesIndex: activeSeries,
              dataPointIndex: i,
              w,
            });
          } else {
            cat = axesUtils.getLabel(w.globals.labels, w.globals.timescaleLabels, 0, i).text;
          }
        }

        // datetime, but labels specified in categories or labels
        if (w.config.xaxis.type === 'datetime') {
          if (w.config.xaxis.categories.length) {
            cat = w.config.xaxis.categories[i];
          } else if (w.config.labels.length) {
            cat = w.config.labels[i];
          }
        }
      }

      if (Array.isArray(cat)) {
        cat = cat.join(' ');
      }

      return ApexUtils.isNumber(cat) ? cat : cat.split(columnDelimiter).join('');
    };

    const handleAxisRowsColumns = (s, sI) => {
      if (columns.length && sI === 0) {
        rows.push(columns.join(columnDelimiter));
      }

      if (s.data && s.data.length) {
        for (let i = 0; i < s.data.length; i++) {
          columns = [];

          let cat = getCat(i);
          if (!cat) {
            if (dataFormat.isFormatXY()) {
              cat = series[sI].data[i].x;
            } else if (dataFormat.isFormat2DArray()) {
              cat = series[sI].data[i] ? series[sI].data[i][0] : '';
            }
          }

          if (sI === 0) {
            columns.push(
              isTimeStamp(cat)
                ? w.config.chart.toolbar.export.csv.dateFormatter(cat)
                : ApexUtils.isNumber(cat)
                ? cat
                : cat.split(columnDelimiter).join('')
            );

            for (let ci = 0; ci < w.globals.series.length; ci++) {
              columns.push(w.globals.series[ci][i]);
            }
          }

          if (w.config.chart.type === 'candlestick' || (s.type && s.type === 'candlestick')) {
            columns.pop();
            columns.push(w.globals.seriesCandleO[sI][i]);
            columns.push(w.globals.seriesCandleH[sI][i]);
            columns.push(w.globals.seriesCandleL[sI][i]);
            columns.push(w.globals.seriesCandleC[sI][i]);
          }

          if (w.config.chart.type === 'boxPlot' || (s.type && s.type === 'boxPlot')) {
            columns.pop();
            columns.push(w.globals.seriesCandleO[sI][i]);
            columns.push(w.globals.seriesCandleH[sI][i]);
            columns.push(w.globals.seriesCandleM[sI][i]);
            columns.push(w.globals.seriesCandleL[sI][i]);
            columns.push(w.globals.seriesCandleC[sI][i]);
          }

          if (w.config.chart.type === 'rangeBar') {
            columns.pop();
            columns.push(w.globals.seriesRangeStart[sI][i]);
            columns.push(w.globals.seriesRangeEnd[sI][i]);
          }

          if (columns.length) {
            rows.push(columns.join(columnDelimiter));
          }
        }
      }
    };
    // first column header
    const columnHeader = options.xaxis?.title?.text || options.table_view_labels_header;
    columnHeader ? columns.push(`${columnHeader}`) : columns.push('');

    series.map((s, sI) => {
      const sname = s.name ? s.name : `series-${sI}`;
      if (w.globals.axisCharts) {
        columns.push(sname.split(columnDelimiter).join('') ? sname.split(columnDelimiter).join('') : `series-${sI}`);
      }
    });

    if (!w.globals.axisCharts) {
      columns.push(LocaleService.t('value'));
      rows.push(columns.join(columnDelimiter));
    }
    series.map((s, sI) => {
      if (w.globals.axisCharts) {
        handleAxisRowsColumns(s, sI);
      } else {
        columns = [];

        columns.push(w.globals.labels[sI].split(columnDelimiter).join(''));
        columns.push(w.globals.series[sI]);
        rows.push(columns.join(columnDelimiter));
      }
    });

    result += rows.join(lineDelimiter);
    return result;
  },
};

export default ApexChartExportService;
